import { Pipe, PipeTransform } from '@angular/core'
import { get } from 'lodash'

@Pipe({
  name: 'map',
})
export class MapPipe implements PipeTransform {
  transform(values: any[] | undefined, arg: string): any {
    if (!values || !Array.isArray(values)) {
      return ''
    }

    return values?.map((item) => get(item, arg))
  }
}
